var render = function render(){var _vm=this,_c=_vm._self._c;return _c('List',[_c('RecycleScroller',{style:(_vm.scrollStyle),attrs:{"items":_vm.dataSource,"item-size":_vm.itemSize,"key-field":_vm.keyField},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return _c('div',{staticClass:"ant-list-item"},[_vm._t("default",null,{"item":item})],2)}}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }